"use client";
import * as React from "react";
const SvgCallRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m14.432 10.91-2.262-.257a1.773 1.773 0 0 0-1.46.507L9.07 12.8A13.4 13.4 0 0 1 3.2 6.93l1.65-1.648c.383-.383.57-.918.507-1.461l-.258-2.244A1.783 1.783 0 0 0 3.326 0H1.785C.778 0-.06.837.003 1.844.475 9.45 6.56 15.524 14.156 15.997c1.007.062 1.844-.775 1.844-1.782v-1.54a1.765 1.765 0 0 0-1.568-1.764Z" }));
export {
  SvgCallRound as default
};
